import { useState, type FormEvent } from "react";
import type { Advertiser, CampaignCreateCommand } from "../api/types";

function localDateTime(date: Date): string {
  const shifted = new Date(date.getTime() - date.getTimezoneOffset() * 60_000);
  return shifted.toISOString().slice(0, 16);
}

export function CampaignForm({
  advertisers,
  busy,
  onSubmit,
}: {
  advertisers: Advertiser[];
  busy: boolean;
  onSubmit: (command: CampaignCreateCommand) => void;
}) {
  const [advertiserId, setAdvertiserId] = useState(advertisers[0]?.id ?? "");
  const [name, setName] = useState("");
  const [startsAt, setStartsAt] = useState(() => localDateTime(new Date()));
  const [endsAt, setEndsAt] = useState("");
  const [ttlUnit, setTtlUnit] = useState<"hours" | "days">("days");
  const [ttl, setTtl] = useState("1");
  const [utmSource, setUtmSource] = useState("alot");
  const [utmMedium, setUtmMedium] = useState("content");
  const [utmCampaign, setUtmCampaign] = useState("");
  const ttlValue = Number(ttl);
  const valid = Boolean(
    advertiserId && name.trim() && startsAt && Number.isInteger(ttlValue) && ttlValue > 0 &&
    utmSource.trim() && utmMedium.trim() && /^[a-z0-9][a-z0-9_-]{0,99}$/.test(utmCampaign),
  ) && (!endsAt || new Date(endsAt) > new Date(startsAt));

  function submit(event: FormEvent) {
    event.preventDefault();
    if (!valid) return;
    onSubmit({
      advertiserId,
      name: name.trim(),
      startsAt: new Date(startsAt).toISOString(),
      ...(endsAt ? { endsAt: new Date(endsAt).toISOString() } : {}),
      ...(ttlUnit === "hours" ? { ttlHours: ttlValue } : { ttlDays: ttlValue }),
      utm: { source: utmSource.trim(), medium: utmMedium.trim(), campaign: utmCampaign },
    });
  }

  return (
    <form className="panel campaign-form" onSubmit={submit}>
      <div className="form-grid">
        <div className="field">
          <label htmlFor="campaign-advertiser">Рекламодатель</label>
          <select id="campaign-advertiser" value={advertiserId} onChange={(event) => setAdvertiserId(event.target.value)}>
            {advertisers.map((advertiser) => <option key={advertiser.id} value={advertiser.id}>{advertiser.displayName}</option>)}
          </select>
        </div>
        <div className="field">
          <label htmlFor="campaign-name">Название</label>
          <input id="campaign-name" maxLength={200} value={name} onChange={(event) => setName(event.target.value)} />
        </div>
        <div className="field">
          <label htmlFor="campaign-start">Начало</label>
          <input id="campaign-start" type="datetime-local" value={startsAt} onChange={(event) => setStartsAt(event.target.value)} />
        </div>
        <div className="field">
          <label htmlFor="campaign-end">Окончание (необязательно)</label>
          <input id="campaign-end" type="datetime-local" value={endsAt} min={startsAt} onChange={(event) => setEndsAt(event.target.value)} />
        </div>
        <div className="field">
          <label htmlFor="campaign-ttl">Срок кэша</label>
          <div className="inline-fields">
            <input id="campaign-ttl" type="number" min="1" max={ttlUnit === "hours" ? 8760 : 365} step="1" value={ttl} onChange={(event) => setTtl(event.target.value)} />
            <select aria-label="Единица срока кэша" value={ttlUnit} onChange={(event) => setTtlUnit(event.target.value as "hours" | "days")}>
              <option value="hours">часов</option><option value="days">дней</option>
            </select>
          </div>
        </div>
      </div>
      <fieldset>
        <legend>UTM-атрибуция</legend>
        <div className="form-grid three-columns">
          <div className="field"><label htmlFor="utm-source">Source</label><input id="utm-source" maxLength={100} value={utmSource} onChange={(event) => setUtmSource(event.target.value)} /></div>
          <div className="field"><label htmlFor="utm-medium">Medium</label><input id="utm-medium" maxLength={100} value={utmMedium} onChange={(event) => setUtmMedium(event.target.value)} /></div>
          <div className="field"><label htmlFor="utm-campaign">Campaign slug</label><input id="utm-campaign" maxLength={100} value={utmCampaign} onChange={(event) => setUtmCampaign(event.target.value.toLowerCase())} placeholder="autumn_jobs" /></div>
        </div>
      </fieldset>
      <button className="primary" type="submit" disabled={busy || !valid}>{busy ? "Сохраняю…" : "Создать кампанию"}</button>
    </form>
  );
}
